"use client";

import styles from "./View.module.scss";

export const View = ({ children }: { children: React.ReactNode }) => {
  return <div className={styles["comp"]}>{children}</div>;
};
